<!-- 三方支付结果页 -->
<template>
  <div class="thrid-pay-result">
    <img class="payback-icon success-icon" src="@/assets/payResult/success.png">
    <h1 class="payback-title">支付成功</h1>
    <hr>
    <h2 class="payback-tip">您已帮他付款</h2>
    <img class="logo-more" src="@/assets/global/logo-more.png">
  </div>
</template>

<script>
export default {
  created() {
    
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style scoped lang="less">
  .thrid-pay-result {
    padding: 1.28rem .64rem .64rem .64rem;
    min-height: 100vh;
    background: #f4f4f8;
    text-align: center;
    box-sizing: border-box;
  }
  .payback-icon {
    display: block;
    margin: 0 auto;
    width: 1.92rem;
    height: 1.92rem;
  }
  .payback-title {
    display: block;
    margin-top: .32rem;
    font-size: .44rem;
    color: #6c6c74;
    font-weight: bold;
  }
  hr {
    display: block;
    margin: 0 auto;
    margin-top: .96rem;
    height: 1px;
    border: none;
    border-top: .01rem solid rgba(0,0,0,.1);
  }
  .payback-tip {
    display: block;
    margin: 0 auto;
    margin-top: .64rem;
    color: #6c6c74;
    font-size: .34rem;
    font-weight: normal;
  }
  .logo-more {
    display: block;
    position: absolute;
    left: 50%;
    bottom: .64rem;
    transform: translateX(-50%);
    margin: 0 auto;
    width: 2.8rem;
  }
</style>
